import styled from 'styled-components';
import { PrsDefaultButton } from '../../../../styles-and-themes/styles/prsButtons';

export const ConfirmationErrorOuterContainer = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const ConfirmationErrorH2 = styled.h2`
  margin: 0;
`;

export const ConfirmationErrorButton = styled(PrsDefaultButton)`
  margin-top: 1rem;
`;
